import React from "react"
import PropTypes from "prop-types"

const getColor = percentage => {
  if (percentage >= 80) {
    return "#49e900"
  } else if (percentage >= 70) {
    return "#ffcc00"
  } else if (percentage >= 50) {
    return "#feaa00"
  } else {
    return "red"
  }
}

const RadialProgressMeter = ({ percentage, color, size, strokeWidth }) => {
  const strokeColor = color ? color : getColor(percentage)

  const radius = size / 2 - strokeWidth / 2
  const circumference = 2 * Math.PI * radius
  const sweep = circumference * (1 - percentage / 100)

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <text
        x="50%"
        y="58%"
        textAnchor="middle"
        style={{
          fontWeight: "bold",
          fontSize: "1.7em"
        }}
        fill="#009fef"
      >
        {percentage}%
      </text>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={sweep}
        transform={`rotate(90 ${size / 2} ${size / 2})`}
      />
    </svg>
  )
}

RadialProgressMeter.propTypes = {
  percentage: PropTypes.number.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number
}

RadialProgressMeter.defaultProps = {
  size: 120,
  strokeWidth: 20
}

export default RadialProgressMeter
